import React, { useState, useEffect } from "react";
import axios from "axios";
import { useMediaQuery } from "react-responsive"; // Importing the hook from react-responsive

const Follow = () => {
  const [instagramPosts, setInstagramPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  // Static fallback data wrapped in useMemo
  const staticInstagramPosts = React.useMemo(() => [
    {
      id: 1,
      image: "https://res.cloudinary.com/dzk6ng1ba/image/upload/v1743073368/Rectangle_113_xho3tv.png",
      alt: "Our ice cream shop interior-0",
      link: "https://www.instagram.com/p/post1"
    },
    {
      id: 2,
      image: "https://res.cloudinary.com/dzk6ng1ba/image/upload/v1743073368/Rectangle_110_ylpg7u.png",
      alt: "New flavor launch-1",
      link: "https://www.instagram.com/p/post2"
    },
    {
      id: 3,
      image: "https://res.cloudinary.com/dzk6ng1ba/image/upload/v1743073368/Rectangle_111_ug5tfz.png",
      alt: "Customer enjoying our product-2",
      link: "https://www.instagram.com/p/post3"
    },
    {
      id: 4,
      image: "https://res.cloudinary.com/dzk6ng1ba/image/upload/v1743073367/Rectangle_108_nbhg5o.png",
      alt: "Special summer offer-3",
      link: "https://www.instagram.com/p/post4"
    },
    {
      id: 5,
      image: "https://res.cloudinary.com/dzk6ng1ba/image/upload/v1743073367/Rectangle_108_nbhg5o.png",
      alt: "Behind the scenes-4",
      link: "https://www.instagram.com/p/post5"
    }
  ], []);

  useEffect(() => {
    // Fetch Instagram posts from the API
    const fetchInstagramFeed = async () => {
      try {
        const response = await axios.get("https://derbyb.ritaz.in/api/instagram/instagram-feed");
        const posts = response.data.data;
        // Filter out video posts
        const filteredPosts = posts.filter(post => post.media_type !== 'VIDEO');

        // Limit to 5 posts
        const limitedPosts = filteredPosts.slice(0, 5);

        setInstagramPosts(limitedPosts); // Update state with the first 5 non-video posts
        setLoading(false); // Set loading to false after data is fetched
      } catch (error) {
        console.error("Error fetching Instagram feed:", error);
        setInstagramPosts(staticInstagramPosts); // Fallback to static data
        setLoading(false); // Stop loading in case of error
      }
    };

    fetchInstagramFeed();
  }, [staticInstagramPosts]);

  // Use media query to check if it's a desktop screen
  const isDesktop = useMediaQuery({ minWidth: 1024 }); // Use the hook unconditionally

  // Show loading text or spinner while the posts are being fetched
  if (loading) {
    return <div>Loading Instagram posts...</div>;
  }

  return (
    <section className="follow-con position-relative">
      <div className="container">
        <div className="row">
          <div className="col-12 position-relative">
            <div className="follow_content text-center" data-aos="fade-up">
              <h2>
                Follow Us on <span>Instagram</span>
              </h2>
              <p>Join our Instagram community for updates, special deals, and more!</p>
            </div>

            {/* Instagram posts grid */}
            <ul
              className="list-unstyled mb-0"
              data-aos="fade-up"
              style={{
                display: isDesktop ? "flex" : "grid",
                gap: "15px",
                gridTemplateColumns: isDesktop ? "repeat(5, 1fr)" : "repeat(2, 1fr)",
                ...((!isDesktop) && {
                  gridTemplateAreas: instagramPosts.length >= 5 ? `
                    "item1 item2"
                    "item3 item4"
                    "item5 item5"
                  ` : "",
                }),
              }}
            >
              {instagramPosts.slice(0, isDesktop ? 5 : 5).map((post, index) => (
                <li 
                  key={index}
                  style={!isDesktop && index === 4 ? { gridArea: 'item5' } : 
                         !isDesktop ? { gridArea: `item${index + 1}` } : {}}
                >
                  <a
                    href={post.permalink}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={`Instagram post ${index + 1}`}
                  >
                    <figure className="image">
                      <img
                        src={post.media_url || post.image}
                        alt={post.alt || `Instagram post ${index + 1}`}
                        className="img-fluid"
                        loading="lazy"
                      />
                    </figure>
                    <div className="icon">
                      <i className="fa-brands fa-instagram" aria-hidden="true"></i>
                    </div>
                  </a>
                </li>
              ))}
            </ul>

            {/* Decorative elements */}
            <div className="circle1"></div>
            <div className="circle2"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Follow;